export const SET_SELECTED_DATE_RANGE = 'SET_SELECTED_DATE_RANGE';
export const SET_SAVE_NOTE = 'SET_SAVE_NOTE';

export function saveSelectedDateRange(payload) {
  return {
    type: SET_SELECTED_DATE_RANGE,
    payload
  };
}

export function onSaveNoteFunction(payload) {
  return {
    type: SET_SAVE_NOTE,
    payload
  };
}
